/**
 * Local dev-menu items injected into the sidebar on allowed dev/test hosts
 * (see `ALLOWED_SERVERS` in side-bar.component.ts).
 *
 * Committed state: empty array — production builds and clean clones get
 * no extra items.
 *
 * To populate this file on your own machine without committing the items:
 *   1. Add your entries to DEV_MENU_ITEMS below.
 *   2. Run once, from the repo root:
 *        git update-index --skip-worktree \
 *          SpendkeyAngular18/src/app/CommonComponents/side-bar/side-bar.dev-menu.ts
 *      Git will now ignore further local edits and never include them in
 *      diffs, status, or commits. Pulls won't overwrite your version
 *      either (they'll surface as a conflict you can resolve).
 *
 * To go back to tracking it normally:
 *        git update-index --no-skip-worktree \
 *          SpendkeyAngular18/src/app/CommonComponents/side-bar/side-bar.dev-menu.ts
 */
export interface DevMenuItem {
  title: string;
  tooltip: string;
  icon: string;
  link: string;
  selected: boolean;
}

export const DEV_MENU_ITEMS: DevMenuItem[] = [
  {
    title: 'Document Analytics',
    tooltip: 'Document Analytics',
    icon: 'icon-Document',
    link: 'document-analytics',
    selected: false,
  },
  {
    title: 'Data Extraction (Single Client)',
    tooltip: 'Data Extraction — single client (Puris SAS) view',
    icon: 'icon-Document',
    link: 'contract-extraction-single',
    selected: false,
  },
];
